import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'System';

const systemSetup = [
  {
    matchRegex: '/Setting/SystemSetup',
    name: getRouteName(MODULE_NAME, 'Setup'),
    slots: [
      SLOT_KEY.SLOT_V_TABLE_TBODY,
    ],
    parentKeys: {
      [SLOT_KEY.SLOT_V_TABLE_TBODY]: [
        {
          key: 'document-numbering-convention-table',
          label: 'Document Numbering Convention Table',
        },
      ],
    },
  },
];

export default systemSetup;
